import DistributionStatus from 'src/app/shared/enums/DistributionStatus.enum';
import DistributionTransactionPurpose from 'src/app/shared/enums/DistributionTransactionPurpose.enum';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';

export class DistributionTableItemResponse {
  public id: number;
  public holdingId: number;
  public status: DistributionStatus;
  public name: string;
  public totalAmountForDistribution: number;
  public periodStartTimeStamp: Date;
  public periodEndTimeStamp: Date;
  public noticeSentTimeStamp: Date;
  public payoutSentTimeStamp: Date;
  public overallSettlementDate: Date;
  public distributionSourceCurrency: CurrencyModel;
  public distributionSourceCurrencyId: number;
  public isGeneratingOrders: boolean;
  public reasonForTransaction: DistributionTransactionPurpose;
  public reasonsForTransaction: DistributionTransactionPurpose[];
}
